<template>
  <div v-loading="isLoading">
    <el-card shadow="never">
      <Consignment
        ref="consignment"
        :form-data="formData.consignmentData"
      />
    </el-card>
  </div>
</template>
<script>
import Consignment from '@/components/Application/Manage/Carriers/Carrier/Consignment'
export default {
  components: {
    Consignment
  },
  data () {
    return {
      title: 'Consignment',
      breadcrumb: {
        name: 'Consignment',
        route: { name: 'manage-carriers-carrier-configurations-consignment' }
      },
      isSaving: false,
      isLoading: false,
      carrier: [],
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ],
      formData: {
        consignmentData: {
          prefixRequired: false,
          length: null,
          prefixDef: null,
          minDef: null,
          maxDef: null,
          quote_template: null
        }
      }
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, (builder) => {
      }).then(res => {
        this.carrier = res
        this.formData.consignmentData.prefixRequired = res.config_con_prefix_req
        this.formData.consignmentData.length = res.con_length
        this.formData.consignmentData.prefixDef = res.config_con_prefix_def
        this.formData.consignmentData.minDef = res.config_con_min_def
        this.formData.consignmentData.maxDef = res.config_con_max_def
        this.formData.consignmentData.quote_template = res.quote_template
      })
        .finally(() => { this.isLoading = false })
    },
    save () {
      this.isSaving = true
      this.carrier.config_con_prefix_req = this.formData.consignmentData.prefixRequired
      this.carrier.con_length = this.formData.consignmentData.length
      this.carrier.config_con_prefix_def = this.formData.consignmentData.prefixDef
      this.carrier.config_con_min_def = this.formData.consignmentData.minDef
      this.carrier.config_con_max_def = this.formData.consignmentData.maxDef
      this.carrier.quote_template = this.formData.consignmentData.quote_template

      this.$refs.consignment.$refs.form.validate((valid) => {
        if (valid) {
          this.carrier.update()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
            })
        }
      })
    }
  }
}
</script>
